import { observer } from "mobx-react-lite";
import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button, Grid, Segment, Popup } from "semantic-ui-react";
import CustomerStore from "../../../app/stores/customerStore";
import CustomerList from "./CustomerList";
import { CSVLink } from "react-csv";

const CustomerDashboard: React.FC = () => {
  const customerStore = useContext(CustomerStore);
  const { customersByName: customersByName } = customerStore;

  useEffect(() => {
    customerStore.loadCustomers();
  }, [customerStore]);

  return (
    <Segment>
      <Grid>
        <Grid.Column width={8}></Grid.Column>
        <Grid.Column width={5}>
          <CSVLink data={customersByName} filename={"customers.csv"}>
            <Popup
              content="Download as CSV"
              trigger={<Button icon="download" floated="right" />}
            />
          </CSVLink>
        </Grid.Column>
        <Grid.Column textAlign="center" width={3}>
          <Button
            as={Link}
            to={"/dailymanagement/customer-create"}
            color="linkedin"
            icon="add"
            content="Create New"
          />
        </Grid.Column>
      </Grid>
      <Grid>
        <Grid.Column>
          <CustomerList />
        </Grid.Column>
      </Grid>
    </Segment>
  );
};

export default observer(CustomerDashboard);
